import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import WhatWeDo from "@/components/WhatWeDo";
import Pricing from "@/components/Pricing";
import HowItWorks from "@/components/HowItWorks";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function Landing() {
  return (
    <div className="App noise bg-background text-foreground" data-testid="app-root">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <WhatWeDo />
        <Pricing />
        <HowItWorks />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
